// =============================================================================
// TableControls.tsx — Top bar controls for the poker table
// Project: Texas Hold'em Social Casino
// =============================================================================
// Shows table info, chip balance, and navigation actions.
// Also triggers interstitial ads on leave.

import React from 'react'
import { useGameStore } from '../store/game-store'
import { usePlayerStore } from '../store/player-store'
import { useUIStore } from '../store/ui-store'

export default function TableControls(): React.ReactElement {
  const { gameState, disconnectFromTable } = useGameStore()
  const { profile } = usePlayerStore()
  const { navigateTo, showToast } = useUIStore()

  const handleLeave = (): void => {
    disconnectFromTable()
    navigateTo('lobby')
    showToast('Left the table', 'info')
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '8px 12px', width: '100%',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
    }}>
      <button className="btn btn-secondary" onClick={handleLeave} style={{ padding: '6px 14px', fontSize: 12 }}>
        ← Leave
      </button>

      <div style={{ textAlign: 'center' }}>
        {gameState && (
          <div style={{ fontSize: 11, color: '#888' }}>
            Hand #{gameState.handNumber} · {gameState.players.filter(p => !p.isAI).length} players
          </div>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ fontSize: 12, color: '#f5c518', fontWeight: 700 }}>
          {profile?.chips.toLocaleString()}
        </div>
      </div>
    </div>
  )
}
